/** Presentation only: retain a handle when it adds information to the name. */
export function distinctIdentityHandle(displayName: string | null | undefined, username: string | null | undefined): string {
  const handle = String(username ?? "").trim().replace(/^@/, "");
  const name = String(displayName ?? "").trim().replace(/^@/, "");
  return handle && name.toLocaleLowerCase() !== handle.toLocaleLowerCase() ? handle : "";
}
